var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4364_101078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39453 11.8789C9.15596 11.8789 11.3945 9.64033 11.3945 6.87891C11.3945 4.11748 9.15596 1.87891 6.39453 1.87891C3.63311 1.87891 1.39453 4.11748 1.39453 6.87891C1.39453 9.64033 3.63311 11.8789 6.39453 11.8789Z",
    stroke: "#9199A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9375 5.37919C5.05505 5.04502 5.28708 4.76324 5.59248 4.58376C5.89788 4.40427 6.25695 4.33866 6.60609 4.39855C6.95523 4.45843 7.27191 4.63995 7.50004 4.91096C7.72817 5.18196 7.85303 5.52495 7.8525 5.87919C7.8525 6.87919 6.3525 7.37919 6.3525 7.37919",
    stroke: "#9199A3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.39453 9.37891H6.39922",
    stroke: "#9199A3",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4364_101078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.652344 0.878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQuestion);
export default __webpack_public_path__ + "static/media/ico-question.6553812aef5892333f0c6b86e8c671c9.svg";
export { ForwardRef as ReactComponent };